export enum EmployeeIdsEnum {
  EP_ORG_EMPLOYEE_DETAILS = 1,
  EP_ACTION_REASSIGN_DEVICE = 35,
  EY_ACTION_PROLONG_DEVICE = 47,
  REWRITES_EMPLOYEE = 3,
  NEW_JOINER = 54,
}
